var hostname = window.location.hostname;
var DEBUG = true;
if (hostname && hostname.indexOf("swoop.de") > -1) {
    var DEBUG = false;
}
if (!DEBUG) {
    if (!window.console)
        window.console = {};
    var methods = ["log", "debug", "warn", "info"];
    for (var i = 0; i < methods.length; i++) {
        console[methods[i]] = function () {
        };
    }
}

$(function () {
    $(window).ready(function () {
//Start Fix MegaNavbar on scroll page
        var navHeight = $('#main_navbar').offset().top;
        FixMegaNavbar(navHeight);
        $(window).bind('scroll', function () {
            FixMegaNavbar(navHeight);
        });

    });

    //Next code used to prevent unexpected menu close when using some components (like accordion, tabs, forms, etc), please add the next JavaScript to your page
    $(window).load(function () {
        $(document).on('click', '.navbar .dropdown-menu', function (e) {
            e.stopPropagation();
        });
    });
});

function FixMegaNavbar(navHeight) {
    if (!$('#main_navbar').hasClass('navbar-fixed-bottom')) {
        if ($(window).scrollTop() > navHeight) {
            $('#main_navbar').addClass('navbar-fixed-top')
            $('body').css({'margin-top': $('#main_navbar').height() + 'px'});
            if ($('#main_navbar').parent('div').hasClass('container'))
                $('#main_navbar').children('div').addClass('container').removeClass('container-fluid');
            else if ($('#main_navbar').parent('div').hasClass('container-fluid'))
                $('#main_navbar').children('div').addClass('container-fluid').removeClass('container');
        }
        else {
            $('#main_navbar').removeClass('navbar-fixed-top');
            $('#main_navbar').children('div').addClass('container-fluid').removeClass('container');
            $('body').css({'margin-top': ''});
        }
    }
}





